<mat-drawer-container>
  <mat-drawer #drawer mode="side" opened disableClose autosize>
    @if(noStates()){
    <div class="text h4">No State Selected</div>
    <div>Please select a state to view the Weather Baseline Report</div>
    }@else{
    <div class="flex-column">
      <h4 class="text h4">
        {{reportName()}} Weather Baseline Report
      </h4>

      <h5 class="text h5">Counties</h5>
      <div>Select counties to see weather event information</div>
      <div class="flex-row space-between">
        <button mat-stroked-button color="primary" (click)="onSelectAllCounties()">
          <span class="button-content">
            <vulcan-icon icon="check" size="16px"></vulcan-icon>
            <span>Select All</span>
          </span>
        </button>
        <button mat-stroked-button color="primary" (click)="onDeselectAllCounties()">
          <span class="button-content">
            <vulcan-icon icon="x" size="16px"></vulcan-icon>
            <span>Deselect All</span>
          </span>
        </button>
      </div>
      <mat-form-field appearance="outline" class="county-list-filter">
        <vulcan-icon class="funnel-icon" matPrefix icon="funnel-simple" size="20px"></vulcan-icon>
        <mat-label class="filter-label">Type to filter counties</mat-label>
        <input type="text" matInput [(ngModel)]="countyFilter">
        <button matSuffix mat-icon-button aria-label="Clear" (click)="countyFilter.set('')">
          <vulcan-icon icon="x" size="20px">close</vulcan-icon>
        </button>
        <mat-hint>showing {{filteredOptions().length}} counties of {{countyOptions().length}}</mat-hint>
      </mat-form-field>
      <div class="filteredCounties">
        @for (county of filteredOptions(); track county.id) {
        <mat-checkbox class="county-checkbox" color="primary" [checked]="county.isSelected()"
          (click)="onCountyToggle(county)">
          {{county.name}}
        </mat-checkbox>
        }
      </div>
      <mat-form-field appearance="outline">
        <mat-label>Select Weather Events</mat-label>
        <mat-select multiple [value]="selectedPhenoms()">
          @for (group of phenomGroups$(); track group.id) {
          <mat-checkbox class="phenom-group-label" color="primary" [indeterminate]="group.isSomeSelected()"
            [checked]="group.isSelected()" (change)="onGroupToggle(group)">
            {{ group.displayName }}
          </mat-checkbox>
          @for (phenom of group.phenoms; track phenom.abbv) {
          <mat-option [value]="phenom" (click)="onPhenomToggle(phenom)"> {{phenom.displayName}}</mat-option>
          }
          }
        </mat-select>
        <mat-hint>
          @if(selectedPhenoms().length === 0){
          No weather events selected
          }@else{
          {{selectedPhenoms().length}} selected weather events
          }
        </mat-hint>
      </mat-form-field>
      <div class="checkbox-row">
        <mat-checkbox color="primary" [checked]="onlyExtremeEvents()"
          (click)="onlyExtremeEvents.set(!onlyExtremeEvents())">
          Only Extreme Events
        </mat-checkbox>
        <!--        <vulcan-icon icon="info" size="14px"></vulcan-icon>-->
      </div>
      <div class="flex-row space-between">
        <mat-form-field appearance="outline">
          <mat-label>Start Date </mat-label>
          <mat-datepicker-toggle matIconPrefix [for]="startDatePicker"></mat-datepicker-toggle>
          <input matInput [matDatepicker]="startDatePicker" [ngModel]="startDate()"
            (ngModelChange)="startDate.set($event)">
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>End Date </mat-label>
          <mat-datepicker-toggle matIconPrefix [for]="endDatePicker"></mat-datepicker-toggle>
          <input matInput [matDatepicker]="endDatePicker" [ngModel]="endDate()" (ngModelChange)="endDate.set($event)">
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    }
  </mat-drawer>
  <mat-drawer-content>

    <div class="flex-column">
      <tgrid-map [mapId]="mapId"></tgrid-map>
      @if( filteredWeatherData().length === 0 ){
      <div class="mask-container">
        <div class="mask-text">{{ maskText() }}</div>
      </div>
      }@else{

      @if( totalWeatherSummary() !== null ){
      <div class="summary-section">
        <mat-card class="summary">
          <mat-card-header>
            All Weather Events
          </mat-card-header>
          <mat-card-content>
            <table>
              @for( entry of totalWeatherSummary()?.eventCountMap | keyvalue; track entry.key ){
              <tr class="events-row">
                <td class="number"> {{entry.value |number}} </td>
                <td class="label"> {{entry.key}} </td>
              </tr>
              }
            </table>

            <div class="summary-divider-row">
              <mat-divider class="summary-divider"></mat-divider>
            </div>
            <div class="total-row">
              <div class="number-total"> {{totalWeatherSummary()?.totalEvents}}</div>
              <div class="label-total">
                <div class="table-label-with-icon">
                  <span>Total Weather Events</span>
                  <!--                  <vulcan-icon icon="help_outline" size="13px"></vulcan-icon>-->
                </div>
              </div>

            </div>

          </mat-card-content>
        </mat-card>
        @if( countySummary() !== null ){
        <mat-card class="summary">
          <mat-card-header>
            <span>Most Impacted Counties</span>
            <!--            <vulcan-icon icon="help_outline" size="13px"></vulcan-icon>-->
          </mat-card-header>
          <mat-card-content>
            <table>
              @for( entry of countySummary(); track entry.county.id ){
              <tr class="county-row">
                <td class="number"> {{entry.count | number}} </td>
                <td class="label"> {{entry.county.name}} County </td>
              </tr>
              }
            </table>
            <div class="summary-divider-row">
              <mat-divider class="summary-divider"></mat-divider>
            </div>
            <div class="county-total">
              <div class="number-total"> {{summaryTotal()}}</div>
              <div class="label-total">
                <div class="table-label-with-icon">
                  <span>Total Weather Events</span>
                  <!--                  <vulcan-icon icon="help_outline" size="13px"></vulcan-icon>-->
                </div>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
        }
      </div>
      }
      <mat-card class="chart-section">
        <tgrid-weather-event-table [events]="filteredWeatherData()"></tgrid-weather-event-table>
      </mat-card>
      }
    </div>
  </mat-drawer-content>

</mat-drawer-container>